import _ from "lodash";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { memo, useCallback } from "react";
import { HPHButton, SliderPanel } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import CopyStdProposalForRecalPanel from "./Copy/CopyStdProposalForRecalPanel";
import ProposalCopyingForRecalEditRightPanel from "./Copy/ProposalCopyingForRecalEditRightPanel";
import UpdatePercentageAndProposalNoForRecalPanel from "./Copy/UpdatePercentageAndProposalNoForRecalPanel";

const TariffItemCopyForRecalRightPanel = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const messageBarVM = useMessageBarVM();
    const { selectedItemRows, currentSelectedRow, copyToNewProposalList, isCopyToNewProposal, companyCodeList, isShowPreviewPanel,
        copyToPercentageList, copyToProposalList, isEditPercentage, isEditProposalNo, isEditNewProposalNo, searchCriteria, searchStatus } = proposalCopyingForRecalState;

    const isCopyDisable = () => {
        if (isEditPercentage || isEditProposalNo || isEditNewProposalNo || isShowPreviewPanel) return true
        return false
    }

    const checkCopy = useCallback(() => {
        return companyCodeList.length > 0 && copyToPercentageList && copyToPercentageList.every(entity =>
            entity.tariffType !== null && entity.tariffType !== undefined && entity.tariffType.trim() !== '' &&
            entity.chargePercentage !== null && entity.chargePercentage !== undefined &&
            entity.roundMethod !== null && entity.roundMethod !== undefined && entity.roundMethod.trim() !== '' &&
            entity.decimalPlace !== null && entity.decimalPlace !== undefined && entity.decimalPlace.trim() !== ''
        ) && copyToProposalList && copyToProposalList.every(entity =>
            entity.companyCode !== null && entity.companyCode !== undefined && entity.companyCode.trim() !== '' &&
            entity.proposalNo !== null && entity.proposalNo !== undefined && entity.proposalNo.trim() !== ''
        );
    }, [companyCodeList, copyToPercentageList, copyToProposalList]);

    const checkNewCopy = useCallback(() => {
        return companyCodeList.length > 0 && copyToPercentageList && copyToPercentageList.every(entity =>
            entity.tariffType !== null && entity.tariffType !== undefined && entity.tariffType.trim() !== '' &&
            entity.chargePercentage !== null && entity.chargePercentage !== undefined &&
            entity.roundMethod !== null && entity.roundMethod !== undefined && entity.roundMethod.trim() !== '' &&
            entity.decimalPlace !== null && entity.decimalPlace !== undefined && entity.decimalPlace.trim() !== ''
        ) && copyToNewProposalList && copyToNewProposalList.every(entity =>
            entity.companyCode !== null && entity.companyCode !== undefined && entity.companyCode.trim() !== '' &&
            entity.effectiveDate !== null && entity.effectiveDate !== undefined &&
            entity.expiryDate !== null && entity.expiryDate !== undefined &&
            entity.currencyCode !== null && entity.currencyCode !== undefined && entity.currencyCode.trim() !== '' &&
            entity.proposalCreatedByMethod !== null && entity.proposalCreatedByMethod !== undefined && entity.proposalCreatedByMethod.trim() !== ''
        );
    }, [companyCodeList.length, copyToNewProposalList, copyToPercentageList]);

    const handlePreview = useCallback(() => {
        if (_.isEmpty(companyCodeList)) {
            messageBarVM.showError("Please select the company code first.");
            return;
        }
        if (isCopyToNewProposal && !checkNewCopy()) {
            messageBarVM.showError("Please input the new proposal's mandatory value first.");
            return;
        }
        if (!isCopyToNewProposal && !checkCopy()) {
            messageBarVM.showError("Please input the % change or select copy to company code's proposal no.");
            return;
        }
        if (isCopyToNewProposal && copyToNewProposalList && !copyToNewProposalList.every(entity =>
            entity.effectiveDate !== null && entity.expiryDate !== null &&
            entity.proposalCreatedByMethod !== null && entity.currencyCode !== null
        )) {
            messageBarVM.showError("Please input the copy to new proposal's Effective Date, Expiry Date, Proposal By, Currency Code.");
            return;
        }
        proposalCopyingForRecalVM.onShowPreviewPanel(isCopyToNewProposal);
    }, [checkCopy, checkNewCopy, companyCodeList, copyToNewProposalList, isCopyToNewProposal, messageBarVM, proposalCopyingForRecalVM]);

    const handleCopy = useCallback(() => {
        if (_.isEmpty(companyCodeList)) {
            messageBarVM.showError("Please select the company code first.");
            return;
        }
        if (isCopyToNewProposal && !checkNewCopy()) {
            messageBarVM.showError("Please input the new proposal's mandatory value first.");
            return;
        }
        if (!isCopyToNewProposal && !checkCopy()) {
            messageBarVM.showError("Please input the % change or select copy to company code's proposal no.");
            return;
        }
        if (isCopyToNewProposal && copyToNewProposalList && !copyToNewProposalList.every(entity =>
            entity.effectiveDate !== null && entity.expiryDate !== null &&
            entity.proposalCreatedByMethod !== null && entity.currencyCode !== null
        )) {
            messageBarVM.showError("Please input the copy to new proposal's Effective Date, Expiry Date, Proposal By, Currency Code.");
            return;
        }
        proposalCopyingForRecalVM.onShowLoading();
        if (!isCopyToNewProposal) {
            proposalCopyingForRecalVM.onTariffItemCombineCopy(selectedItemRows, copyToPercentageList, copyToProposalList, currentSelectedRow).then(async (data) => {
                if ((data && data.success)) {
                    if (searchStatus !== "") {
                        await proposalCopyingForRecalVM.onGroupButtonClick(searchStatus);
                    } else {
                        await proposalCopyingForRecalVM.searchNewProposalsForRecal();
                        await proposalCopyingForRecalVM.searchProposalsForRecal(searchCriteria);
                    }
                    proposalCopyingForRecalVM.onHideLoading();
                    messageBarVM.showSuccess("Copy Successfully");
                } else {
                    messageBarVM.showError(data.data ?? "Copy Failed");
                    proposalCopyingForRecalVM.onHideLoading();
                    return;
                }
            });
        } else {
            proposalCopyingForRecalVM.onTariffItemNewCopy(selectedItemRows, copyToPercentageList, copyToNewProposalList, currentSelectedRow).then(async (data) => {
                if ((data && data.success)) {
                    if (searchStatus !== "") {
                        await proposalCopyingForRecalVM.onGroupButtonClick(searchStatus);
                    } else {
                        await proposalCopyingForRecalVM.searchNewProposalsForRecal();
                        await proposalCopyingForRecalVM.searchProposalsForRecal(searchCriteria);
                    }
                    proposalCopyingForRecalVM.onHideLoading();
                    messageBarVM.showSuccess("Copy Successfully");
                } else {
                    messageBarVM.showError(data.data ?? "Copy Failed");
                    proposalCopyingForRecalVM.onHideLoading();
                    return;
                }
            });
        }
    }, [companyCodeList, isCopyToNewProposal, checkNewCopy, checkCopy, copyToNewProposalList, proposalCopyingForRecalVM, messageBarVM, selectedItemRows, copyToPercentageList, copyToProposalList, currentSelectedRow, searchStatus, searchCriteria]);


    return <>
        <div className={`main-comp-wrapper${(isEditPercentage || isEditProposalNo || isEditNewProposalNo) ? '' : ' im-hide-side-form-draggable'}`}>
            <div style={{ width: '100%', height: '100%', maxHeight: '85%' }}>
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={(isEditPercentage || isEditProposalNo || isEditNewProposalNo || isShowPreviewPanel) ? "40%" : "100%"}
                    rightSectionWidth={(isEditPercentage || isEditProposalNo || isEditNewProposalNo || isShowPreviewPanel) ? "60%" : "0%"}
                    leftChildren={<CopyStdProposalForRecalPanel />}
                    rightChildren={isShowPreviewPanel ? <ProposalCopyingForRecalEditRightPanel /> : <UpdatePercentageAndProposalNoForRecalPanel />}
                />
            </div>

            <div style={{ paddingRight: '20px', visibility: isCopyDisable() ? 'hidden' : 'visible', height: '100%', maxHeight: '15%' }} >
                <SidebarActionBar>
                    {<HPHButton disabled={isCopyDisable()} label={"Preview"} size={'Small'} theme={'Secondary'} onClick={handlePreview} />}
                    {<HPHButton disabled={_.isEmpty(companyCodeList)} label={WorkspaceConstant.Common.BUTTON_CONFIRM} size={'Small'} theme={'Primary'} onClick={handleCopy} />}
                </SidebarActionBar>
            </div>

        </div>
    </>
}

export default memo(TariffItemCopyForRecalRightPanel);